module.exports = __webpack_public_path__ + "img/safe-2-fill.131fbfc9.svg";